/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef, useContext } from "react";
import { Collapse } from "antd";
import Api from "../../../../services/ServiceApi";
import StoptimeModal from "./StoptimeModal";
import Stoptimecard from "./Stop_time_card";
import { TotalTime } from "../../../utility/format";
import Renderbtn from "../../../../pages/uih/wf_controllers/BtnController/renderButton";
import { authUserContext } from "../../../../contexts";

const { Panel } = Collapse;

function Stoptime({
  title,
  language,
  factupdate,
  CompanyId,
  OperatorId,
  ProjectId,
  headerdata,
  Workflowdata,
  Jobdata,
  canEditstart,
  canEditend,
}) {
  const auth = useContext(authUserContext);
  // console.log("auth",auth);
  const locale = auth.locale;
  const { result_stop_time, result_total_stop_times, result_oper_job_pic } =
    Jobdata;
  const unmounted = useRef(false);
  const [modalOpen, setmodalOpen] = useState(false);
  const [StartorStop, setStartorStop] = useState(true);
  const [hideBtn, sethideBtn] = useState(true);
  const [editMode, seteditMode] = useState(false);
  const [initEditData, setinitEditData] = useState(null);
  const configVisibleComponent =
    auth.configuration?.filter(
      (s) => (s) => s.configuration.job_full_detail.component !== null
    )[0]?.configuration.job_full_detail?.component.stoptime.visible ?? true;
  useEffect(() => {
    if (Workflowdata) {
      Workflowdata.map((data) => {
        if (data.from_main_process_id === 3 && data.next_main_action_id === 5) {
          setStartorStop(true);
          sethideBtn(false);
        } else if (
          data.from_main_process_id === 3 &&
          data.next_main_action_id === 6
        ) {
          setStartorStop(false);
          sethideBtn(false);
        }
      });
    }

    return () => {
      unmounted.current = true;
    };
  }, [Jobdata, Workflowdata, result_stop_time]);

  const ModalOpen = () => {
    setmodalOpen(true);
  };

  return (
    <>
      {configVisibleComponent ? (
        <Collapse
          className="container"
          expandIconPosition="right"
          defaultActiveKey={["1"]}
        >
          <Panel
            header={
              <>
                <img
                  src={Api.absoluteUrl(`/icon/stop_time.svg`)}
                  alt={title}
                  title={title}
                />
                <h4>{title}</h4>
              </>
            }
            key="1"
          >
            <div className="d-flex align-items-center justify-content-between flex-wrap pb-2">
              {result_stop_time.length > 0 ? (
                <div>
                  <TotalTime
                    title={`Total Time : `}
                    wrapClassName="font-weight-bold"
                    days={result_total_stop_times[0]?.total_days}
                    hour={result_total_stop_times[0]?.total_hours}
                    min={result_total_stop_times[0]?.total_minutes}
                  ></TotalTime>
                </div>
              ) : (
                <div></div>
              )}
              <div>
                {!hideBtn ? (
                  StartorStop ? (
                    <Renderbtn
                      renderBtn={{
                        visible: true,
                        html_tag: "button",
                        type: "FAwithText",
                        icon_align: "left",
                        font_awasome: "fas fa-stop fa-xs mr-2",
                        text: factupdate
                          ? language[locale]["stop_time"]
                          : `Stop Time`,
                        css: "btn btn-danger btn-xs font-thai-r fs-18 ",
                      }}
                      btnMiddleware={ModalOpen}
                      index="view_stop_time"
                      item={null}
                      disable={false}
                    ></Renderbtn>
                  ) : (
                    <Renderbtn
                      renderBtn={{
                        visible: true,
                        html_tag: "label",
                        type: "Text", // type: "ImagewithText",
                        text: "Wait for Start Time",
                        image_path: "/icon/bbtec/button/md/start-time.svg",
                        icon_align: "left",
                        css: "btn btn-sm btn-outline-success",
                      }}
                      index="view_label_starttime_1"
                    ></Renderbtn>
                  )
                ) : null}
              </div>
            </div>
            {result_stop_time.length > 0 ? (
              result_stop_time.map((data, index) => (
                <div key={`stop_time_${index + 1}`} className="card mb-2">
                  <Stoptimecard
                    key={`stop_time_crad_index_${index}`}
                    data={data}
                    pic={result_oper_job_pic?.filter(
                      (s) =>
                        s.company_id === data.company_id &&
                        s.operator_id === data.operator_id &&
                        s.project_id === data.project_id &&
                        s.pic_type === "T" &&
                        s.reference_id === data.job_stop_id
                    )}
                    language={language}
                    factupdate={factupdate}
                    seteditMode={seteditMode}
                    setinitEditData={setinitEditData}
                    showBtn={true}
                    // showBtn={+auth.teamId === 101}
                  ></Stoptimecard>
                </div>
              ))
            ) : (
              <div className="row justify-content-center">
                <span>ไม่พบข้อมูลการขอหยุดเวลา</span>
              </div>
            )}
          </Panel>
        </Collapse>
      ) : null}
      {modalOpen ? (
        <StoptimeModal
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          modalOpen={modalOpen}
          setmodalOpen={setmodalOpen}
          language={language}
          factupdate={factupdate}
          job_id={headerdata.job_id}
          job_progress_id={headerdata.job_progress_id}
          job_type_id={headerdata.job_type_id}
          Workflowdata={Workflowdata}
          canEditstart={true}
          canEditend={true}
          wrapClassName={`bbtec-theme`}
        ></StoptimeModal>
      ) : null}
      {editMode ? (
        <StoptimeModal
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          modalOpen={editMode}
          setmodalOpen={seteditMode}
          language={language}
          factupdate={factupdate}
          job_id={headerdata.job_id}
          job_progress_id={headerdata.job_progress_id}
          job_type_id={headerdata.job_type_id}
          Workflowdata={Workflowdata}
          canEditstart={true}
          canEditend={true}
          wrapClassName={`bbtec-theme`}
          editMode={true}
          initData={initEditData}
        ></StoptimeModal>
      ) : null}
    </>
  );
}

export default Stoptime;
